// When serving static HTML (e.g. nginx) there is no RSC server; use client-only routing instead.
if (
  typeof document !== "undefined" &&
  document.documentElement.getAttribute("data-static") === "true"
) {
  import("./client-static").then((m) => {
    m.mountStaticApp();
    console.log("[EriConnect] Client (static) mounted");
  });
} else {
  import("rwsdk/client").then(({ initClient }) => {
    console.log("[EriConnect] Initializing client...");
    initClient();
    console.log("[EriConnect] Client initialized");
  });
}
